import Dispatcher from '../../../flux/dispatcher/dispatcher';
import Constants from '../../Dashboard/constants/GetHistogramConstant';
// var Dispatcher = require('dispatcher/dispatcher');
var EventEmitter = require('events').EventEmitter;
var RESPONSE_CHANGE_EVENT = 'globalResponse';
// var Constants = require('components/Dashboard/constants/GetHistogramConstant');
var assign = require('object-assign');

var response = {};

function parseResponse(resp) {
    localStorage.setItem("profileId", resp.profileId);
    localStorage.setItem("profileName", resp.profileName);
    localStorage.setItem("masterLocationFilter", resp.masterLocationFilter);
    response = resp;
}

var ChangeProfileStore = assign({}, EventEmitter.prototype, {
    emitChangeEvent: function (event) {
        this.emit(event);
    },
    bind: function (callback) {
        this.on(RESPONSE_CHANGE_EVENT, callback);
    },
    unbind: function (callback) {
        this.removeListener(RESPONSE_CHANGE_EVENT, callback);
    },
    getResponse: function () {
        return response;
    }
});

Dispatcher.register(function (action) {

    switch (action.actionType) {
        case Constants.PROFILE_CHANGED:
            var resp = action.data;
            parseResponse(resp)
            ChangeProfileStore.emitChangeEvent(RESPONSE_CHANGE_EVENT)
            break;
            
        default:
    }
});

export default ChangeProfileStore;